@if (loading()) {
  <div class="loading-state">
    {{ 'common.messages.loading' | translate }}
  </div>
} @else if (detail()) {
  <div class="detail-grid">
    <div class="detail-item">
      <label>{{ 'return_exception.detail.ticket_code' | translate }}</label>
      <span>{{ detail()?.ticketCode }}</span>
    </div>
    <div class="detail-item">
      <label>{{ 'return_exception.detail.status' | translate }}</label>
      <span>{{ getStatusLabel(detail()?.status) }}</span>
    </div>
    <div class="detail-item">
      <label>{{ 'return_exception.detail.store' | translate }}</label>
      <span>{{ storeDisplay() }}</span>
    </div>
    <div class="detail-item">
      <label>{{ 'return_exception.detail.customer_phone' | translate }}</label>
      <span>{{ detail()?.customerPhone }}</span>
    </div>
    <div class="detail-item">
      <label>{{ 'return_exception.detail.customer_name' | translate }}</label>
      <span>{{ detail()?.customerName }}</span>
    </div>
    <div class="detail-item">
      <label>{{ 'return_exception.detail.created_at' | translate }}</label>
      <span>{{ formatDateTime(detail()?.creationDate) }}</span>
    </div>
    @if (detail()?.reasonCode) {
      <div class="detail-item">
        <label>{{ 'return_exception.detail.reason_code' | translate }}</label>
        <span>{{ detail()?.reasonCode }}</span>
      </div>
    }
    @if (detail()?.reasonNote) {
      <div class="detail-item full-width">
        <label>{{ 'return_exception.detail.reason_note' | translate }}</label>
        <span>{{ detail()?.reasonNote }}</span>
      </div>
    }
    @if (detail()?.cancelReason) {
      <div class="detail-item full-width">
        <label>{{ 'return_exception.detail.cancel_reason' | translate }}</label>
        <span>{{ detail()?.cancelReason }}</span>
      </div>
    }
  </div>

  @if ((detail()?.lines?.length ?? 0) > 0) {
    <h4>{{ 'return_exception.detail.lines_title' | translate }}</h4>
    <table class="lines-table p-datatable-table">
      <thead>
        <tr>
          <th>{{ 'return_exception.detail.line_sku' | translate }}</th>
          <th>{{ 'return_exception.detail.line_qty' | translate }}</th>
          <th>{{ 'return_exception.detail.line_condition' | translate }}</th>
          <th>{{ 'return_exception.detail.line_lot' | translate }}</th>
          <th>{{ 'return_exception.detail.line_expiry' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (line of detail()?.lines ?? []; track line.id) {
          <tr>
            <td>{{ line.skuCode }} — {{ line.skuName }}</td>
            <td>{{ line.quantity }}</td>
            <td>{{ line.itemCondition }}</td>
            <td>{{ line.lotValue }}</td>
            <td>{{ line.expiryDate }}</td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (galleryImages().length > 0) {
    <div class="gallery-section">
      <h4>{{ 'return_exception.detail.images_title' | translate }}</h4>
      <app-galleria [images]="galleryImages()" [config]="galleryConfig" />
    </div>
  }
}
